/* hs-eslint ignored failing-rules */
'use es6';

import { jsx as _jsx } from "react/jsx-runtime";
import PropTypes from 'prop-types';
import { Component } from 'react';
import { connect } from 'react-redux';
import UIAlert from 'UIComponents/alert/UIAlert';
import FormattedMessage from 'I18n/components/FormattedMessage';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import { isPaidHub } from 'self-service-api/core/utilities/parcelUtils';
import { setSetting } from 'self-service-api/core/api/settingsApi';
import { isPartnerProgramEligibleSelector } from 'pricing-pages-unified-ui/selectors/PartnerProgramSelectors';
import { settingsValueSelector } from 'pricing-pages-unified-ui/selectors/SettingsSelectors';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
const BANNER_DISMISSED_KEY = 'partner-program:dismissed-banner';

class PartnerProgramBanner extends Component {
  constructor(props) {
    super(props);
    this.state = {
      shouldShowBanner: false
    };
    this.closeBanner = this.closeBanner.bind(this);
    this.handleClick = this.handleClick.bind(this);
  }

  componentDidMount() {
    this.isMounted_ = true;
    const {
      isPartnerProgramEligible,
      isBannerDismissed
    } = this.props;
    isPaidHub().then(hasPaidProduct => {
      if (!this.isMounted_) return;
      const shouldShowBanner = isPartnerProgramEligible && !hasPaidProduct && !isBannerDismissed;
      this.setState({
        shouldShowBanner
      });
    }).catch(error => {
      console.error(error);
      this.setState({
        shouldShowBanner: false
      });
    });
  }

  componentWillUnmount() {
    this.isMounted_ = false;
  }

  closeBanner() {
    this.setState({
      shouldShowBanner: false
    });
    setSetting(BANNER_DISMISSED_KEY, true);
  }

  handleClick() {
    getUsageTracker().track('externalLinkClick', {
      name: 'partner-banner-more-info'
    });
  }

  render() {
    const {
      shouldShowBanner
    } = this.state;
    if (!shouldShowBanner) return null;
    return /*#__PURE__*/_jsx(UIAlert, {
      "data-selenium-id": "partner-program-banner",
      type: "info",
      closeable: true,
      onClose: this.closeBanner,
      titleText: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "pricingPage.promotions.partnerProgram.title"
      }),
      children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
        message: "pricingPage.promotions.partnerProgram.text",
        onClick: this.handleClick
      })
    });
  }

}

PartnerProgramBanner.propTypes = {
  isPartnerProgramEligible: PropTypes.bool.isRequired,
  isBannerDismissed: PropTypes.bool.isRequired
};

const mapStateToProps = state => ({
  isPartnerProgramEligible: isPartnerProgramEligibleSelector(state),
  isBannerDismissed: settingsValueSelector(state, BANNER_DISMISSED_KEY)
});

export default connect(mapStateToProps)(PartnerProgramBanner);